import { Moment } from 'moment';
import { Utils } from '../../model/_utils';
import { InputSearchComponent } from '../input-search/input-search.component';
import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter, HostBinding, HostListener, ElementRef, ChangeDetectorRef, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { DocumentType } from 'src/app/modules/warmi/accounts-receivable/model/documentType.model';
import { EntityFilterSelectComponent } from '../entity-filter-select/entity-filter-select.component';
import { HierarchicalRelationEnum } from 'src/app/modules/warmi/my-account/model/project-settings.model';
import { AuthService } from 'src/app/modules/auth';

export enum DropdownFilterType {
  SELECT = 'SELECT',
  INPUT_FROM_UNTIL_DATE = 'INPUT_FROM_UNTIL_DATE',
  INPUT_FROM_UNTIL_NUMBER = 'INPUT_FROM_UNTIL_NUMBER',
  CHECKBOX_SWITCH = 'CHECKBOX_SWITCH',
  CHECKBOX_SWITCH_AI = 'CHECKBOX_SWITCH_AI',
  SELECT_SINGLE = 'SELECT_SINGLE',
  SELECT_CLIENT_ID = 'SELECT_CLIENT_ID',
  SELECT_CREDIT_ID = 'SELECT_CREDIT_ID',
  SELECT_PAYMENT_ORDER_ID = 'SELECT_PAYMENT_ORDER_ID',
  SELECT_TRADE_NAME_CLIENT = 'SELECT_TRADE_NAME_CLIENT',
  SELECT_PRODUCT_OP = 'SELECT_PRODUCT_OP',
  SELECT_EXTRA_FIELDS = 'SELECT_EXTRA_FIELDS',
  SELECT_PRODUCT_CREDIT = 'SELECT_PRODUCT_CREDIT',
  SELECT_CAMPAIGN_FILTER = 'SELECT_CAMPAIGN_FILTER',
  SELECT_SOURCES_CREDIT = 'SELECT_SOURCES_CREDIT',
  SELECT_SINGLE_MARKETPLACE = 'SELECT_SINGLE_MARKETPLACE',
  VAR6_FROM_USER = 'VAR6_FROM_USER',
  INPUT = 'INPUT',
  INPUT_TEXT_AND_NUMBER = 'INPUT_TEXT_AND_NUMBER',

  SELECT_PRODUCT_PURCHASE_ORDER = 'SELECT_PRODUCT_PURCHASE_ORDER',
  SELECT_PERIOD_PURCHASE_ORDER = 'SELECT_PERIOD_PURCHASE_ORDER',
  SELECT_SALE_EXTERNAL_ID_PURCHASE_ORDER = 'SELECT_SALE_EXTERNAL_ID_PURCHASE_ORDER',
  SELECT_COLLECTION_BANK_NAME = 'SELECT_COLLECTION_BANK_NAME',
  SELECT_RECOVERY_CAMPAIGN_CODE = 'SELECT_RECOVERY_CAMPAIGN_CODE',
  SELECT_PROJECT_CUSTOM_VARIABLE = 'SELECT_PROJECT_CUSTOM_VARIABLE'
}

export class DropdownFilter {
  id?: string | number;
  title: string;
  data: DropdownFilterDetail[];
  selected: DropdownFilterDetail[] | any[] | null;
  singleSelection?: DropdownFilterDetail | any | null;
  value?: any;
  defaultValue?: any;
  value2?: any;
  type?: DropdownFilterType = DropdownFilterType.SELECT;
  hide?: boolean = false;
  filterDataOfPosition?: number | null = null;
  maxDaysBetween?: number;
  value2Max?: any;
  key?: string;
  selectedListFilter?: any[];
  popover?: string;
  save?: boolean;
  blockRemove?: boolean;
  forceInitList?: boolean;
  fieldName?: string; // variable dinamico para el campo extrafields de clientes
  typesProductCredit?: string[];
  onlyByUserProductCredit?: boolean;
  statusCampaignList?: string[];
  minSearchLengthCustomList?: number;
  paymentBalanceType? : string;
  hierarchicalLevel?: number; // nivel jerárquico para filtrar clientes
  hierarchicalRelation? : string;
  economicSectorId? : number;
  showStatusDot?: boolean;
  enabledSearchForSelected? : boolean;
  minDate?: Date | null;
  maxDate?: Date | null;
}

export class DropdownFilterDetail {
  value: any;
  label: string;
  belongsTo?: any = null;
  hide?: boolean = false;
  id?: any = null;
  additionalValue?: string | null = null;
  status?: string;
}
@Component({
  selector: 'app-dropdown-filter',
  templateUrl: './dropdown-filter.component.html',
  styleUrls: ['./dropdown-filter.component.scss']
})
export class DropdownFilterComponent implements OnInit, OnChanges {

  @Input() filter: DropdownFilter[] | null = null;
  @Input() toggleButtonRef: HTMLElement | null = null;
  @Input() seachComponent: InputSearchComponent | null = null;

  @Input() appendTo: string | null;

  @Output() messageEvent = new EventEmitter<any>();
  @Output() saveEvent = new EventEmitter<any>();
  @Output() resetEvent = new EventEmitter<any>();
  @Output() datePickerIsOpen = new EventEmitter<boolean>(false);
  @Output() clickOutside = new EventEmitter<boolean>(false);

  @Input() showButtonSave: boolean = true;
  @Input() showButtonReset: boolean = true;

  @HostBinding('class') class = 'menu menu-sub menu-sub-dropdown w-350px menu-sub-custom';
  @HostBinding('attr.data-kt-menu') dataKtMenu = 'true';

  @Input() minMonthsFromTodayLimit: number | null = null;
  @Output() changeFilterPortfolioType = new EventEmitter<DropdownFilter>();

  minDateLimit: Date | null;

  datePickerIsOpenFlag: boolean = false;
  positionToValidate: { position: number; values: any[] }[] = [];
  nowData: Moment = moment.default().set('hour', 0).set('minute', 0).set('second', 0).clone();

  @Input() documentTypes: DocumentType[] = [];

  BUTTON_CLEAR = "C";

  @Input() isCreditModule: boolean;
  @Input() customVariableType : string;
  hierarchicalRelation : string;


  @ViewChild('clientSelect') clientSelectComponent: EntityFilterSelectComponent;
  @ViewChild('creditSelect') creditSelectComponent: EntityFilterSelectComponent;
  @ViewChild('paymentOrderSelect') paymentOrderSelectComponent: EntityFilterSelectComponent;
  @ViewChild('productPaymentOrderSelect') productPaymentOrderSelect: EntityFilterSelectComponent;
  @ViewChild('tradeNameSelect') tradeNameSelect: EntityFilterSelectComponent;
  @ViewChild('extraFieldsSelect') extraFieldsSelect: EntityFilterSelectComponent;
  @ViewChild('productCreditSelect') productCreditSelect: EntityFilterSelectComponent;
  @ViewChild('sourcesCreditSelect') sourcesCreditSelect: EntityFilterSelectComponent;
  @ViewChild('campaignFilterSelect') campaignFilterSelect: EntityFilterSelectComponent;
  @ViewChild('productPurchaseOrderSelect') productPurchaseOrderSelect: EntityFilterSelectComponent;
  @ViewChild('periodPurchaseOrderSelect') periodPurchaseOrderSelect: EntityFilterSelectComponent;
  @ViewChild('saleExternalIdPurchaseOrderSelect') saleExternalIdPurchaseOrderSelect: EntityFilterSelectComponent;
  @ViewChild('collectionReconciliationSelect') collectionReconciliationSelect: EntityFilterSelectComponent;
  @ViewChild('projectCustomVariableSelect') projectCustomVariableSelect: EntityFilterSelectComponent;

  constructor(
    private elem: ElementRef,
    private cd: ChangeDetectorRef,
    private _authService : AuthService,
  ) {
    this.hierarchicalRelation =  this._authService.decryptedToken()?.hierarchicalRelation || HierarchicalRelationEnum.DEFAULT;
   }

  ngOnInit() {
    this.applyHierarchicalRelationFilter();
    if (this.minMonthsFromTodayLimit) {
      this.minDateLimit = new Date(new Date().getFullYear(), new Date().getMonth() - this.minMonthsFromTodayLimit, 1);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filter'] && !changes['filter'].firstChange) {
      this.applyHierarchicalRelationFilter();
    }
  }

  private applyHierarchicalRelationFilter(): void {
    if (this.hierarchicalRelation == HierarchicalRelationEnum.DEFAULT) {
      this.filter = this.filter?.filter(x => !x.hierarchicalRelation || x.hierarchicalRelation === HierarchicalRelationEnum.DEFAULT) || [];
    } else if (this.hierarchicalRelation == HierarchicalRelationEnum.LEVEL_2) {
      this.filter = this.filter?.filter(x => !x.hierarchicalRelation || x.hierarchicalRelation === HierarchicalRelationEnum.LEVEL_2) || [];
    }
  }

  saveFilters() {
    this.saveEvent.emit(this.filter);
  }

  sendFilters() {
    this.messageEvent.emit(this.filter);
  }

  resetFilter() {
    this.cleanFilter(false);
    this.resetEvent.emit();
  }

  cleanFilter(sendFilter : boolean = false) {
    this.filter?.forEach(e => {
      e.selected = null;
      e.singleSelection = null;
      e.value = e.defaultValue ?? null;
      e.value2 = null;
      e.selectedListFilter = [];
      this.paymentOrderSelectComponent?.clear();
      this.productPaymentOrderSelect?.clear();
      this.clientSelectComponent?.clear();
      this.creditSelectComponent?.clear();
      this.extraFieldsSelect?.clear();
      this.productCreditSelect?.clear();
      this.sourcesCreditSelect?.clear();
      this.campaignFilterSelect?.clear();
      this.productPurchaseOrderSelect?.clear();
      this.periodPurchaseOrderSelect?.clear();
      this.saleExternalIdPurchaseOrderSelect?.clear();
      this.collectionReconciliationSelect?.clear();
      this.projectCustomVariableSelect?.clear();
      this.tradeNameSelect?.clear();
    })
    this.seachComponent?.cleanSearch();
    if (sendFilter) this.sendFilters();
  }

  canRemoveElement(index: number) {
    let element = this.filter?.find((e, i) => i == index);
    return !element?.blockRemove
  }

  deleteOneFilter(index: any) {
    this.filter?.find((e, i) => {
      if (i == index) {
        e.selected = null;
        e.value = e.defaultValue ?? null;
        e.value2 = null;
        e.singleSelection = null;
        e.selectedListFilter = [];
      }
    })
    this.sendFilters()
  }

  emitDatePickerIsOpen($event: boolean) {
    this.datePickerIsOpenFlag = $event;
    this.datePickerIsOpen.emit($event);
  }

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    const htmlTarget = event.target as HTMLElement;
    const isInsideOverlay = !!htmlTarget.closest(
      '.ng-dropdown-panel, .ng-select, .mat-datepicker-popup, .cdk-overlay-container'
    );

    if (this.elem.nativeElement.contains(htmlTarget) || isInsideOverlay || (this.toggleButtonRef && this.toggleButtonRef.contains(htmlTarget))) {
      return;
    }

    if (!this.datePickerIsOpenFlag) {
      this.clickOutside.emit(true);
    }
    /* let htmlTarget = event.target as HTMLElement;
    let htmlTargetParent = (htmlTarget.parentElement as HTMLElement)?.parentElement as HTMLElement;

    if (this.elem.nativeElement.contains(event.target) ||
      (htmlTarget.classList.contains('ng-value-icon') && htmlTarget.classList.contains('left') && htmlTarget.tagName.toLocaleUpperCase() == 'SPAN') ||
      htmlTarget.classList.contains('ng-clear-filter') || htmlTarget.classList.contains('ng-option') ||
      htmlTargetParent?.classList.contains('ng-option-label') ||
      htmlTargetParent?.classList.contains('ng-option') ||
      htmlTargetParent?.classList.contains('ng-dropdown-panel') ||
      (this.toggleButtonRef && this.toggleButtonRef.contains(event.target as HTMLElement))) {

    } else {
      if (!this.datePickerIsOpenFlag) {
        this.clickOutside.emit(true);
      }
    } */
  }

  onSelectSingleChange(item: DropdownFilter, selection: any) {
    item.singleSelection = selection;
    this.changeFilterPortfolioType.emit(item);
  }

  add($event: any, index: number) {

    if (this.filter) {
      if (!this.filter[index].type || this.filter[index].type == "SELECT") {
        let allSelected = false;
        if ($event.value == Utils.getAllFilterValue()) {
          let allOption = this.filter[index].selected?.find(x => x.value == Utils.getAllFilterValue());
          if (allOption) {
            this.filter[index].selected = [allOption];
            allSelected = true;
          }
        }
        if ($event.value != Utils.getAllFilterValue()) {
          let NotFilterAllAndNone = this.filter[index].selected?.filter(x => x.value != Utils.getAllFilterValue())
          if (NotFilterAllAndNone) this.filter[index].selected = NotFilterAllAndNone;
        }

        if (this.filter[index].filterDataOfPosition != null && this.filter[index].filterDataOfPosition != undefined) {
          let position = this.filter[index].filterDataOfPosition || -1;

          if (position != -1) {
            let removeValues: any[] = [];
            if (allSelected) {
            }
            this.filter[position].selected = [];

            for (let i = 0; i < this.filter[position].data.length; i++) {
              if (!allSelected) {
                if (this.filter[position].data[i].value == Utils.getAllFilterValue() || this.filter[position].data[i].value == Utils.getAiAgentFilterValue()) continue;
                let belongsToValue = this.filter[position].data[i].belongsTo;
                if (belongsToValue == null && belongsToValue == undefined || !this.filter[index].selected?.length) this.filter[position].data[i].hide = true;
                else this.filter[position].data[i].hide = !this.filter[position].data[i].belongsTo ? false : (this.filter[index].selected?.findIndex(x => x.value == belongsToValue) == -1);
                if (this.filter[position].data[i].hide) removeValues.push(this.filter[position].data[i].value)
              } else {
                this.filter[position].data = this.filter[position].data.map(x => {
                  x.hide = false;
                  return x;
                })
              }
            }
            if (this.filter[position].selected?.length) this.filter[position].selected = this.filter[position].selected?.filter(x => removeValues.indexOf(x.value) == -1) || [];
          }
        }


      }
    }

  }

  canShowOption(parentValue: any, value: any, index: number) {
    let position = this.filter?.findIndex(x => x.filterDataOfPosition == index);
    if (!this.filter) return true;
    if (position == -1 || position == undefined) return true;
    if (this.filter[position].selected?.length) {
      let selectedValues = this.filter[position].selected?.map(x => x.value)
      let show = selectedValues?.indexOf(parentValue) != -1;
      if (!show && this.filter[position]?.selected?.length) this.filter[position].selected = this.filter[position].selected?.filter(x => x.value != value) || [];
      return show;
    }
    return false;
  }

  getMaxDate(value: Moment, item?: DropdownFilter) {
    const itemMaxDate = item?.maxDate
      ? moment.default(item.maxDate).clone().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      : null;

    if (value && item?.maxDaysBetween) {
      item.value2Max = value.clone().add(item.maxDaysBetween, 'days').set('hour', 0).set('minute', 0).set('second', 0).clone();
      let max = (item.value2Max as Moment).isAfter(this.nowData) ? this.nowData : item.value2Max;
      if (itemMaxDate && max.isAfter(itemMaxDate)) {
        max = itemMaxDate;
      }
      return max;
    }

    if (itemMaxDate) {
      return itemMaxDate;
    }

    return item?.maxDaysBetween ? this.nowData : null;
  }

  changeDate(item: DropdownFilter) {
    if (item.value && item.value2 && item.maxDaysBetween && item.value2Max) {
      item.value2Max = this.getMaxDate(item.value, item);
      if ((item.value2 as Moment).isAfter(item.value2Max)) {
        item.value2 = item.value2Max.clone();
        this.cd.markForCheck();
      }
    }
  }

  selectOption(item: DropdownFilter, detail: DropdownFilterDetail) {
    item.selected = [detail];
    if (detail.value === this.BUTTON_CLEAR) {
      this.resetFilter();
    }
    this.sendFilters();
  }

  get DropdownFilterType(){
   return DropdownFilterType;
  }

  close(){
    this.clickOutside.emit(true);
  }

}
